class BootstrapService {

    constructor(
        $http,
        appConfig,
        GoogleSSOService
    ) {
        'ngInject';

        this.$http = $http;
        this.appConfig = appConfig;
        this.GoogleSSOService = GoogleSSOService;
    }

    $onInit() {
        this.data = {};
    }

    /***
     * Update this Service with information about the site's settings in bootstrap
     */
    initializeSettings() {

        return this.$http.get(`${this.appConfig.apiUrl}/bootstrap/`)
            .then((successResponse) => {
                this.data = successResponse.data;
                this.GoogleSSOService.initGoogleSSO(this.data.googleClientId);
            }, (errorResponse)=>  {
                if (errorResponse.status == 403) {
                    this.data = null;
                }
            }
        );
    }
}

export default BootstrapService;


// WEBPACK FOOTER //
// ./app/common/bootstrap/bootstrap-service.js